export default {
  compare_data_imported: '/user/import/compare-data-imported',
  resolve_warning_attributes: '/user/import/resolve-warning-attribute',
  import_contestant_list: '/import/data/upload-contestants-file',
  create_contestant: '/contest/enrol/create-contestant',
  fetch_exam_subject: '/exam-round/schema-form/get-exam-rounds-for-select-box',
  fetch_exam_shift: '/exam-shift/schema-form/get-exam-shifts-for-select-box',
};
